import DefaultLayout from "./default";
import WideLayout from "./wide";
import MiniLayout from "./mini";
import SmallLayout from "./small";
import CleanLayout from "./clean";
import FormLayout from "./form";
import FrameLayout from "./frame";

export const Default = DefaultLayout;
export const Wide = WideLayout;
export const Mini = MiniLayout;
export const Small = SmallLayout;
export const Clean = CleanLayout;
export const Form = FormLayout;
export const Frame = FrameLayout;
